import Vue from "vue";
import store from "./store";
import Router from "vue-router";
//import native_capacitor from "@/config/js_helper/native_capacitor";
import comming_routes from "./config/router_array/routes.js";

Vue.use(Router);

var router = new Router({
	//mode: "history",
	base: process.env.BASE_URL,
	routes: comming_routes
});

router.beforeEach((to, from, next) => {
	if (to.name == 'home') {
		store.state.active_loader = false;
	} else {
		store.state.active_loader = true;
	}
	if (store.state.other_dialog_active) {
		next(false);
	} else {
		next(!store.state.is_dialog_active);
	}
});
/* router.afterEach((to, from, next) => {
	console.log(router.app.firebaseinited)
	if (router.app.firebaseinited) {
		let langpath = 'sq'
		if (router.app.$store) {
			langpath = router.app.$store.state.type_language == 2 ? 'en' : 'sq'
		}
		let page_location = window.location.href.split('#')
		page_location = 'https://app.tiranamobility.altirana.com/' + langpath + page_location[1]
		native_capacitor.FirebaseAnalytics.logEvent({
			name: 'page_view',
			params: {
				page_title: to.meta.title,
				page_location: to.path,
				page_location: page_location
			}
		})
	}
}); */

export default router;
